import { useNavigate } from 'react-router-dom';
import { Box, Flex, Text, chakra } from '@chakra-ui/react';
import { Logo } from '@/components/ui/Logo/Logo';
import { OrganizationSignupForm } from './components/OrganizationSignupForm/OrganizationSignupForm';

export const OrganizationSignupPage = () => {
  const navigate = useNavigate();

  return (
    <Flex
      minH="100vh"
      bgGradient="to-b"
      gradientFrom="gray.50"
      gradientTo="white"
      justify="center"
      align="center"
      px="4"
      py="12"
      overflowY="auto"
    >
      <Box
        w="full"
        maxW="440px"
        borderRadius="xl"
        border="1px solid"
        borderColor="volyx.borderLight"
        bg="white"
        boxShadow="lg"
        overflow="hidden"
      >
        <Box p="8">
          <Flex justify="center" mb="2">
            <Logo mb="0" />
          </Flex>
          <Text as="h1" mt="0" fontSize="2xl" fontWeight="semibold" lineHeight="snug" color="volyx.text" textAlign="center">
            Create your organization account
          </Text>
          <Text mt="2" fontSize="sm" color="volyx.textSecondary" textAlign="center">
            Enter your organization details below.
          </Text>

          <Box mt="6">
            <OrganizationSignupForm />
          </Box>

          <chakra.button
            type="button"
            w="full"
            h="12"
            mt="4"
            px="6"
            borderRadius="xl"
            fontWeight="semibold"
            transition="all 0.2s"
            cursor="pointer"
            border="1px solid"
            borderColor="volyx.borderLight"
            bg="white"
            color="volyx.text"
            _hover={{ bg: 'gray.50' }}
            _focus={{ outline: 'none' }}
            onClick={() => navigate('/signup')}
          >
            Back
          </chakra.button>
        </Box>
      </Box>
    </Flex>
  );
};
